// Copyright 2025. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const AuthPageHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 48px;
`;
